import { useQuery } from '@tanstack/react-query';
import { OrganizerV1, QK } from 'ck-queries';
import { fetchWithErrorThrowing } from 'ck-utils';

export const useOrganizer = (committeeId: string | undefined) => {
  return useQuery({
    queryKey: [QK.organizers, committeeId],
    queryFn: () => getOrganizer(committeeId),
    enabled: !!committeeId,
  });
};

async function getOrganizer(
  committeeId: string | undefined
): Promise<OrganizerV1> {
  const res = await fetchWithErrorThrowing(`/organizer-pages/${committeeId}`, {
    method: 'GET',
  });

  const data: OrganizerV1 = await res.json();
  return data;
}
